import { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import ContextComponent from "../AppContext";
import Login from "./Login";
import ResetPassword from "./ResetPassword";
import Mask from "../controls/Mask";
import Alert from "../controls/alerts/Alert";
import LandingPage from "./LandingPage";
import Utils from "../Utils";

function MainPage() {
  let [loadingState, setLoadingState] = useState(false);

  let [alert, setAlert] = useState({});
  let [canRedirectToLogin, setCanRedirectToLogin] = useState(false);
  let [canRedirectToResetPassword, setCanRedirectToResetPassword] =
    useState(false);
  let [canRedirectToLanding, setCanRedirectToLanding] = useState(false);
  let [userData, setUserData] = useState({});
  let [sitesCtxData, setSitesCtxData] = useState([]);
  let [folderStructure, setFolderStructure] = useState([]);
  let [virtualFolderData, setVirtualFolderData] = useState([]);

  let navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add("indi-app");

    if (canRedirectToLogin) {
      Utils.deleteSession();
      setCanRedirectToLogin(false);
      navigate(Utils.APP_URLS.LOGIN_PAGE);
    }
  }, [navigate, canRedirectToLogin]);

  useEffect(() => {
    document.body.classList.add("indi-app");

    if (canRedirectToResetPassword) {
      setCanRedirectToResetPassword(false);
      navigate(Utils.APP_URLS.RESET_PASSWORD_PAGE);
    }
  }, [navigate, canRedirectToResetPassword]);

  useEffect(() => {
    document.body.classList.add("indi-app");

    if (canRedirectToLanding) {
      setCanRedirectToLanding(false);
      navigate(Utils.APP_URLS.LANDING_PAGE);
    }
  }, [navigate, canRedirectToLanding]);

  return (
    <ContextComponent.Provider
      value={{
        loadingState,
        setLoadingState,
        alert,
        setAlert,
        canRedirectToLogin,
        setCanRedirectToLogin,
        canRedirectToLanding,
        setCanRedirectToLanding,
        setCanRedirectToResetPassword,
        userData,
        setUserData,
        sitesCtxData,
        setSitesCtxData,
        folderStructure,
        setFolderStructure,
        virtualFolderData,
        setVirtualFolderData,
      }}
    >
      <Mask />
      <Alert />
      <Routes>
        <Route
          path={Utils.APP_URLS.LOGIN_PAGE}
          exact
          element={<Login />}
        ></Route>
        <Route
          path={Utils.APP_URLS.RESET_PASSWORD_PAGE}
          exact
          element={<ResetPassword />}
        ></Route>

        <Route path={`/*`} element={<LandingPage />}></Route>
      </Routes>
    </ContextComponent.Provider>
  );
}

export default MainPage;
